import { Box, Drawer } from '@mui/material';
import { AppMenu } from './AppMenu.tsx';

interface AppDrawerProps {
	drawerWidth: number;
	mobileOpen: boolean;
	onDrawerToggle: () => void;
}

const AppNavigation = ({ drawerWidth, mobileOpen, onDrawerToggle }: AppDrawerProps) => {
	const drawerContent = (
		<Box sx={{ mt: '74px' }}>
			<AppMenu />
		</Box>
	);

	return (
		<Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}>
			{/* Mobile drawer */}
			<Drawer
				variant="temporary"
				open={mobileOpen}
				onClose={onDrawerToggle}
				ModalProps={{ keepMounted: true }}
				sx={{
					display: { xs: 'block', sm: 'none' },
					'& .MuiDrawer-paper': {
						width: drawerWidth,
						boxSizing: 'border-box',
						background: '#000',
						color: '#fff',
					},
				}}
				className="no-print"
			>
				{drawerContent}
			</Drawer>

			{/* Desktop drawer */}
			<Drawer
				variant="permanent"
				sx={{
					display: { xs: 'none', sm: 'block' },
					'& .MuiDrawer-paper': {
						width: drawerWidth,
						boxSizing: 'border-box',
						background: '#000',
						color: '#fff',
					},
				}}
				open
				className="no-print"
			>
				{drawerContent}
			</Drawer>
		</Box>
	);
};

export { AppNavigation };
